import { useState } from 'react';

export default function ImpactAnalysis() {
  const [formData, setFormData] = useState({
    businessImpact: '',
    operationalImpact: '',
    dataImpact: '',
    reputationalImpact: '',
    financialImpact: '',
    regulatoryImpact: '',
    impactScope: '',
    estimatedRecoveryTime: '',
    resourceRequirements: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="space-y-6 mt-6">
      <div className="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
        <div className="md:grid md:grid-cols-3 md:gap-6">
          <div className="md:col-span-1">
            <h3 className="text-lg font-medium leading-6 text-gray-900">Impact Assessment</h3>
            <p className="mt-1 text-sm text-gray-500">
              Evaluate the various impacts of the incident.
            </p>
          </div>
          <div className="mt-5 md:mt-0 md:col-span-2">
            <div className="grid grid-cols-6 gap-6">
              <div className="col-span-6">
                <label htmlFor="businessImpact" className="block text-sm font-medium text-gray-700">
                  Business Impact
                </label>
                <select
                  id="businessImpact"
                  name="businessImpact"
                  value={formData.businessImpact}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                >
                  <option value="">Select impact level...</option>
                  <option value="none">None</option>
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                  <option value="critical">Critical</option>
                </select>
              </div>

              <div className="col-span-6">
                <label htmlFor="operationalImpact" className="block text-sm font-medium text-gray-700">
                  Operational Impact
                </label>
                <textarea
                  id="operationalImpact"
                  name="operationalImpact"
                  rows={3}
                  value={formData.operationalImpact}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Describe the impact on business operations"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="dataImpact" className="block text-sm font-medium text-gray-700">
                  Data Impact
                </label>
                <textarea
                  id="dataImpact"
                  name="dataImpact"
                  rows={3}
                  value={formData.dataImpact}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Describe any data loss or compromise"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="reputationalImpact" className="block text-sm font-medium text-gray-700">
                  Reputational Impact
                </label>
                <textarea
                  id="reputationalImpact"
                  name="reputationalImpact"
                  rows={3}
                  value={formData.reputationalImpact}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Assess potential impact on organization's reputation"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="financialImpact" className="block text-sm font-medium text-gray-700">
                  Financial Impact
                </label>
                <textarea
                  id="financialImpact"
                  name="financialImpact"
                  rows={3}
                  value={formData.financialImpact}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Estimate financial impact and costs"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="regulatoryImpact" className="block text-sm font-medium text-gray-700">
                  Regulatory Impact
                </label>
                <textarea
                  id="regulatoryImpact"
                  name="regulatoryImpact"
                  rows={3}
                  value={formData.regulatoryImpact}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Identify any regulatory compliance issues"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="impactScope" className="block text-sm font-medium text-gray-700">
                  Impact Scope
                </label>
                <textarea
                  id="impactScope"
                  name="impactScope"
                  rows={3}
                  value={formData.impactScope}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Define the scope of impact"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="estimatedRecoveryTime" className="block text-sm font-medium text-gray-700">
                  Estimated Recovery Time
                </label>
                <textarea
                  id="estimatedRecoveryTime"
                  name="estimatedRecoveryTime"
                  rows={2}
                  value={formData.estimatedRecoveryTime}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Estimate time required for recovery"
                />
              </div>

              <div className="col-span-6">
                <label htmlFor="resourceRequirements" className="block text-sm font-medium text-gray-700">
                  Resource Requirements
                </label>
                <textarea
                  id="resourceRequirements"
                  name="resourceRequirements"
                  rows={3}
                  value={formData.resourceRequirements}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="List required resources for incident handling"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}